<template>
  <div class="content1">
    <el-form ref="ruleForm" :model="form" :rules="rules" label-width="160px">
      <div class="box">
        <div class="title">
          基本信息
        </div>
        <el-form-item label="报表名称" class="fixedWidth" prop="title">
          <!-- <el-input v-model="form.title" size="mini"></el-input> -->
          <el-select
            v-model="form.region"
            placeholder="请选择活动区域"
            size="mini"
          >
            <el-option label="名称一" value="shanghai"></el-option>
            <el-option label="名称二" value="beijing"></el-option>
          </el-select>
        </el-form-item>
      </div>
      <div class="box">
        <div class="title">
          报表时间
        </div>
        <el-form-item label="时间周期" prop="title">
          <el-radio-group v-model="form.period">
            <el-radio
              v-for="(item, index) in periodData"
              :label="item.value"
              :key="index"
            >
              {{ item.label }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="更新设置" prop="title">
          <el-radio-group v-model="form.update">
            <el-radio
              v-for="(item, index) in updateData"
              :label="item.value"
              :key="index"
            >
              {{ item.label }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 自定义时间 -->
        <el-form-item
          label="自定义时间"
          prop="start_time"
          v-if="form.update == '0'"
        >
          <div>
            <el-date-picker
              v-model="form.start_time"
              type="date"
              class="inputWidth"
              placeholder="开始日期"
              value-format="yyyy-MM-dd"
              size="small"
            ></el-date-picker>
            <span class="inputMargin">至</span>
            <el-date-picker
              v-model="form.end_time"
              type="date"
              class="inputWidth"
              placeholder="结束日期"
              value-format="yyyy-MM-dd"
              size="small"
            ></el-date-picker>
            <!-- <div class="color">
              报表到期后将自动失效，失效后不可延长
            </div> -->
          </div>
        </el-form-item>
        <!-- 自然小时 -->
        <el-form-item
          label="时间范围"
          prop="title"
          v-if="form.period == '0' && form.update == '1'"
        >
          <el-radio-group v-model="form.periodHour">
            <el-radio :value="0">近1天</el-radio>
            <el-radio :value="1">近7天</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 自然日 -->
        <el-form-item
          label="时间范围"
          prop="title"
          v-if="form.period == '1' && form.update == '1'"
        >
          <el-radio-group v-model="form.periodDay">
            <el-radio :value="0">近1天</el-radio>
            <el-radio :value="1">近7天</el-radio>
            <el-radio :value="2">近30天</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 自然周 -->
        <el-form-item
          label="时间范围"
          prop="title"
          v-if="form.period == '2' && form.update == '1'"
        >
          <el-radio-group v-model="form.periodWeek">
            <el-radio :value="0">近8周</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 自然月 -->
        <el-form-item
          label="时间范围"
          prop="title"
          v-if="form.period == '3' && form.update == '1'"
        >
          <el-radio-group v-model="form.periodMoon">
            <el-radio :value="0">近6个月</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
    </el-form>
    <!-- 底部提交 -->
    <div class="bottom">
      <el-button @click="$router.go(-1)">取消</el-button>
      <el-button type="primary" @click="submit('ruleForm')">确定</el-button>
    </div>
    <!-- 优惠券弹窗 -->
    <el-dialog :visible.sync="showSelecter" @close="showSelecter = false">
      <newSelectCommodityNum
        @close="showSelecter = false"
        @getCommod="getCommod"
        :sList="sList"
        :jude="2"
      ></newSelectCommodityNum>
    </el-dialog>
  </div>
</template>
<script>
import newSelectCommodityNum from "@/components/commodity/newSelectCommodityNum.vue";
import multipleChoice from "@/components/commodity/multipleChoice.vue";
import { mapGetters } from "vuex";
import { storeSelect } from "@/api/employee";
import { vipList } from "@/api/vip";
import time from "@/utils/time";
import { addAttention, editAttention, detailAttention } from "@/api/market";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  components: {
    newSelectCommodityNum,
    multipleChoice
  },
  data() {
    return {
      periodData: [
        {
          label: "分小时",
          value: "0"
        },
        {
          label: "自然日",
          value: "1"
        },
        {
          label: "自然周",
          value: "2"
        },
        {
          label: "自然月",
          value: "3"
        }
      ],
      updateData: [
        {
          label: "不自动更新",
          value: "0"
        },
        {
          label: "自动更新",
          value: "1"
        }
      ],
      initStatus: false,
      jude: this.$route.query.status,
      // end
      checkList: [],
      form: {
        title: "",
        start_time: "", //报表开始时间
        end_time: "",
        //
        period: "0", //时间周期
        update: "0", //更新设置
        periodDay: "0", //自然日
        periodWeek: "0", //自然周
        periodMoon: "0", //自然yue
        periodHour: "0" //自然小时
      },
      rules: {
        title: [{ required: true, message: "请输入报表名称", trigger: "blur" }],
        start_time: [
          { required: true, message: "请输入报表开始时间", trigger: "blur" }
        ]
      },
      // 规则一，报表层级
      // form.give_status: "0",
      // 数字转成汉字
      tranformHanzi: {}
    };
  },
  beforeMount() {
    // if (this.$route.query.status != 0) {
    //   this.initStatus = true;
    //   console.log("我走这一步", this.$route.query.status);
    //   this.details();
    // }
  },
  methods: {
    // 提交
    submitSS(formitem) {
      this.$nextTick(() => {
        this.form;
      });
      console.log("提交之前的数据", this.form);
      this.$refs[formitem].validate(valid => {
        if (valid) {
          let data = { ...this.form };
          data.app_id = this.app_id;
          data.token = this.token;
          if (this.jude == 0) {
            addAttention(data).then(res => {
              if (res.code == 200) {
                this.$message.success("保存成功");
                this.$router.go(-1);
              } else {
                this.$message.warning(res.msg);
              }
              console.log("保存", res);
            });
          } else {
            editAttention(data).then(res => {
              if (res.code == 200) {
                this.$message.success("编辑成功");
                this.$router.go(-1);
              } else {
                this.$message.warning(res.msg);
              }
              console.log("保存", res);
              console.log("编辑", res);
            });
          }
          console.log("data", data);
        } else {
          this.$message.warning("请填写必填项！！");
        }
      });
    },
    //选择优惠券
    getCommod(data) {
      console.log("子组件传递数据", data);
      let arrCountId = [];
      data.forEach(item => {
        if (item.choseNum) {
          for (var n = 0; n < Number(item.choseNum); n++) {
            arrCountId.push(item.id);
          }
        }
      });
      this.sList = data;

      this.form.coupon = arrCountId.join(",");
      // this.sList = data;
      this.showSelecter = false;
      console.log("点击", this.form.coupon, this.sList);
    },
    //删除选择的优惠券
    delTagItem(x) {
      console.log(x);
      this.sList.splice(x, 1);
      let j = 0;
      let idArr = [];
      for (j in this.sList) {
        idArr.push(this.sList[j].id);
      }
      this.form.coupon = idArr.join(",");
      console.log("删除", this.form.coupon, this.sList);
    },
    selectCoupon() {
      console.log("选择优惠券");
      this.sList = this.sList;
      this.showSelecter = true;
    },
    details() {
      detailAttention({
        token: this.token,
        app_id: this.app_id,
        id: this.jude
      }).then(res => {
        console.log("vip", res);
        this.form = res.data;
        delete this.form.create_time;
        delete this.form.update_time;
        this.form.start_time = time.setDate(this.form.start_time);
        this.form.end_time = time.setDate(this.form.end_time);
        this.sList = this.form.coupon_list;
        // 优惠券选择数量
        let couponIds = this.form.coupon.split(",");

        let i = 0;
        for (i in this.sList) {
          let dNum = "0";

          for (let d = 0; d < couponIds.length; d++) {
            if (this.sList[i].id == couponIds[d]) {
              dNum++;
            }
          }
          this.sList[i].choseNum = dNum;
          this.sList[i].name = this.sList[i].title;
          this.sList[i].url =
            "https://zltc-1255680458.cos.ap-beijing.myqcloud.com/1576482532.jpg";
        }
        console.log("wef", this.form.rule);
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.colorRed {
  color: red;
  padding: 0 6px;
}
.el-form-item {
  margin-bottom: 15px;
}
.content1 {
  border: 1px solid #f1f1f1;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  height: 100%;
  // 上层
  .el-form {
    flex: 1;
    padding: 0 20px 10px 20px;
    overflow-y: auto;
    .box {
      background: #f2f2f6;
      margin-top: 20px;
      padding: 10px;
      border-radius: 6px;
      .title {
        font-weight: 550;
        padding: 10px 0px 10px 20px;
      }
      // 样式
      .fontSize14 {
        font-size: 14px;
      }
      .textAlign {
        text-align: right;
      }
      .color {
        margin: 0px 5px;
        color: #999;
        font-size: 12px;
      }
      .inputMargin {
        width: auto;
        margin: 0 6px;
      }
      .inputWidth {
        height: 30px;
        width: 130px;
      }
      .newInputWidth {
        height: 30px;
        width: 120px;
      }
      .fixedButton {
        width: 70px;
      }
      .width30 {
        width: 30px;
        font-size: 14px;
      }
      .marginBottom10 {
        margin-bottom: 20px;
      }
    }
    // 表格
    .table {
      max-width: 900px;
      border: 1px solid #fff;
      background: #fff;
      height: 100%;
      display: flex;
      border-radius: 6px;
      > div {
        padding: 20px;
      }
      .name {
        font-weight: 550;
        padding: none;
      }
      .table-left {
        width: 220px;
        border-right: 1px solid #f1f1f1;
      }
      .table-right {
        flex: 1;
        .marginBottom {
          margin-bottom: 10px;
        }
        margin-bottom: 10px;
      }
    }
  }
  // 底部
  .bottom {
    border-top: 1px solid #f2f2f6;
    height: 60px;
    line-height: 60px;
    background: #fff;
    text-align: center;
    width: 100%;
    padding: 0 20px;
  }

  .flex {
    display: flex;
    align-items: center;
  }
  .fixedWidth {
    width: 500px;
    .line {
      text-align: center;
    }
  }
  .fixedWidth60 {
    width: 60px;
    padding-right: 6px;
  }
}
</style>
